export class Patient {
    constructor( 
        public PatientID?: string,
        public ClinicID?: string,
        public ClinicName?: string,
        public FirstName?: string,
        public MiddleName?: string,
        public LastName?: string,
        public DateOfBirth?: string,
        public IsMale?: boolean,
        public Email?: string,
        public Phone?: string,
        public Medications?: string,
        public CreatedBy?: string,
        public CreatedOn?: Date,
        public bDeleted?: boolean,
        public DeletedBy?: string,
        public DeletedOn?: Date,
    ) {}
}